import { render, staticRenderFns } from "./exportDataPage.vue?vue&type=template&id=42996bf4&scoped=true"
import script from "./exportDataPage.vue?vue&type=script&lang=js"
export * from "./exportDataPage.vue?vue&type=script&lang=js"
import style0 from "./exportDataPage.vue?vue&type=style&index=0&id=42996bf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42996bf4",
  null
  
)

export default component.exports